import { render, staticRenderFns } from "./LetterTrack.vue?vue&type=template&id=472eb586&"
import script from "./LetterTrack.vue?vue&type=script&lang=ts&"
export * from "./LetterTrack.vue?vue&type=script&lang=ts&"
import style0 from "./LetterTrack.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports